import styles from "./SectionVisibilityIcon.module.css";

const DEFAULT_PUBLISHABLE_TOOLTIP =
  "These fields will appear on legal500.com. The total count shown depends on the firm's subscription level.";
const DEFAULT_INTERNAL_TOOLTIP = "Internal only — these fields are not shown on legal500.com";

type PublishableIconProps = {
  tooltip?: string;
};

export function PublishableIcon({ tooltip }: PublishableIconProps) {
  return (
    <span
      className={styles.publishableIcon}
      data-tooltip={tooltip ?? DEFAULT_PUBLISHABLE_TOOLTIP}
      aria-label="Publishable field"
    >
      <svg
        width="14"
        height="14"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <circle cx="12" cy="12" r="10" />
        <line x1="2" y1="12" x2="22" y2="12" />
        <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" />
      </svg>
    </span>
  );
}

type InternalIconProps = {
  tooltip?: string;
};

export function InternalIcon({ tooltip }: InternalIconProps) {
  return (
    <span
      className={styles.internalIcon}
      data-tooltip={tooltip ?? DEFAULT_INTERNAL_TOOLTIP}
      aria-label="Internal field"
    >
      <svg
        width="14"
        height="14"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
        <path d="M7 11V7a5 5 0 0 1 10 0v4" />
      </svg>
    </span>
  );
}

export function SectionVisibilityIcon({
  publishable,
  tooltip,
}: {
  publishable: boolean;
  tooltip?: string;
}) {
  return (
    <span className={styles.sectionPublishableIcon}>
      {publishable ? <PublishableIcon tooltip={tooltip} /> : <InternalIcon tooltip={tooltip} />}
    </span>
  );
}
